import React from 'react';
import { Modal, Input, Form, Select } from 'antd';
import { FORMAT_2DECIMALS } from '../../../common/types/regularExpresionType';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    complete2Decimals = (e) => {
        if (e.target.value === '')
            this.props.form.setFieldsValue({ porcentaje: '0.00' });
        else {
            var number = parseFloat(e.target.value);
            var porcentaje = Number.isNaN(number) ? '0.00' : number.toFixed(2);
            this.props.form.setFieldsValue({ porcentaje: porcentaje });
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    codigoSunat: values.codigoSunat,
                    porcentaje: parseFloat(parseFloat(values.porcentaje).toFixed(2)),
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Existencia" : "Modificar Existencia"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        disabled={this.props.formValues.flagSunat}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Código Sunat">
                                {getFieldDecorator('codigoSunat', {
                                    initialValue: this.props.formValues.codigoSunat,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Input
                                        className="text-right"
                                        placeholder="Ingresar"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Porcentaje">
                                {getFieldDecorator('porcentaje', {
                                    initialValue: parseFloat(this.props.formValues.porcentaje).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato decimal incorrecto (0.00)"
                                    }]
                                })(
                                    <Input
                                        addonAfter="%"
                                        className="text-right"
                                        placeholder="Ingresar porcentaje"
                                        autoComplete="off"
                                        onBlur={this.complete2Decimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)